class BlockKind {
	static ACTION = 'ACTION';
	static FUNCTION = 'FUNCTION';
}

export default BlockKind;
